export enum InfoManagementPermissions {
  ManagementAdmin = 'management-admin',
  Management = 'management',
}
